import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { nameMaxLength } from '../../Constant.js'
import axios from 'axios'
import CheckPermission from '../../common/Permissions/CheckPermission.js'

class EventCategoryAdd extends React.Component {
  state = {
    is_active: 'true',
    category_name_en: '',
    category_name_ar: '',
    category_img_url: '',
    category_type: 'Event',
    isSaving: false,
    isData: false,
    Edit: false,

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',
  }
  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    await axios
      .get(Constant.getAPI() + `/event-categories/list-event-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          const matchItem = res.data?.data?.filter((itm) => itm.id === this.props.category_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
            this.setState({ Edit: true })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }
  onSaveDataBoat = () => {
    var that = this
    const formData = new FormData()
    formData.append('category_name_en', this.state.category_name_en)
    formData.append('category_name_ar', this.state.category_name_ar)
    formData.append('category_type', this.state.category_type)
    formData.append('is_active', this.state.is_active)

    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)
    formData.append('h1_ar', this.state.h1_ar)
    formData.append('h1_en', this.state.h1_en)
    formData.append('h2_ar', this.state.h2_ar)
    formData.append('h2_en', this.state.h2_en)

    if (this.props.category_id) {
      that.setState({ isData: true })
      formData.append('id', this.props.category_id)

      if (this.state.category_img_url?.name) {
        formData.append('category_img_url', this.state.category_img_url)
      }
      axios
        .put(Constant.getAPI() + '/event-categories/edit-event-category', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Event Category has been Updated`, 'success')
            window.location.href = `#/event-category`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      that.setState({ isData: true })
      if (this.state.category_img_url) {
        formData.append('category_img_url', this.state.category_img_url)
      }
      axios
        .post(Constant.getAPI() + '/event-categories/add-event-category', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Event Category has been Added`, 'success')
            window.location.href = `#/event-category`
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }
  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Category Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="category_name_en"
                    id="category_name_en"
                    placeholder=" Category Name: English"
                    onChange={this.handleChange}
                    maxLength={nameMaxLength}
                    value={this.state.category_name_en}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.category_name_en
                    ? this.state.category_name_en.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Category Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="category_name_ar"
                    id="category_name_ar"
                    placeholder="Category Name: Arabic"
                    onChange={this.handleChange}
                    maxLength={nameMaxLength}
                    value={this.state.category_name_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.category_name_ar
                    ? this.state.category_name_ar.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Category Type</label>
                <div className="col-sm-9">
                  <select
                    name="category_type"
                    className="form-control"
                    value={this.state.category_type}
                    onChange={this.handleChange}
                  >
                    <option value="EVENT">EVENT</option>
                    <option value="ACTIVITY">ACTIVITY</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3"> Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="category_img_url"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {this.state.Edit ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.category_img_url}
                      alt="img"
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.img}
                      alt="img"
                    />
                  )}
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
              <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</h5>
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_en"
                      id="meta_title_en"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_title_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_ar"
                      id="meta_title_ar"
                      placeholder=" "
                      onChange={this.handleChange}
                      value={this.state.meta_title_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Keywords: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_en"
                      id="meta_keywords_en"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Keywords: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_ar"
                      id="meta_keywords_ar"
                      placeholder=""
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_en"
                      id="meta_desc_en"
                      value={this.state.meta_desc_en}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_ar"
                      id="meta_desc_ar"
                      value={this.state.meta_desc_ar}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_en"
                      id="h1_en"
                      placeholder="H1: English"
                      onChange={this.handleChange}
                      value={this.state.h1_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_ar"
                      id="h1_ar"
                      placeholder="H1: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h1_ar}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_en"
                      id="h2_en"
                      placeholder="H2: English"
                      onChange={this.handleChange}
                      value={this.state.h2_en}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_ar"
                      id="h2_ar"
                      placeholder="H2: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h2_ar}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveDataBoat}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            {/* <button onClick={this.onSaveDataBoat} className="btn btn-grd-disabled mr-2"><i className="icofont icofont-save"></i> Save</button> */}

            <Link
              to={`/event-category`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default EventCategoryAdd
